import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface EligibleItem {
  fj190_01: string;
  fj190_11: string;
  fj190_12: string;
  fj190_23: string;
  fj190_90: string;
  fj190_80: string;
}

export interface SearchResponse {
  items: EligibleItem[];
  total: number;
}

export interface ExecuteResultItem {
  doc_no: string;
  success: boolean;
  message: string;
}

export interface ExecuteResponse {
  results: ExecuteResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface SearchFilter {
  startNo: string;
  endNo: string;
}

// ============================================================
// API methods
// ============================================================

export const j5m8Api = {
  // POST /api/j5m8/search
  async search(filter: SearchFilter): Promise<SearchResponse> {
    const res = await apiClient.post('/api/j5m8/search', {
      start_no: filter.startNo,
      end_no: filter.endNo,
    });
    return res.data;
  },

  // POST /api/j5m8/execute
  async execute(docNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/j5m8/execute', { doc_nos: docNos });
    return res.data;
  },
};
